package org.example.project.screens_cus

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper

@Composable
fun CusInfrageneratorDashboard() {
    CusBereichWrapper(
        screenKey = "InfrageneratorDashboard",
        buttonLabels = mapOf(
            "TorAuskunft" to "Tor",
            "PlatzAuskunft" to "Hallenplatz",
            "WAPlatzAuskunft" to "WA Platz",
            "ParkplatzAuskunft" to "Parkplatz"
        )
    )
}
